// extracted by mini-css-extract-plugin
export default {"header":"Header_header__invJH","nav":"Header_nav__hdojv","logo":"Header_logo__7OegJ","link-item":"Header_link-item__hZ33G"};